module.exports = {"pathContext":{"name":"PriceTierInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"tier","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"unitFee","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-price-tier-input.json
// module id = 1513
// module chunks = 148728742654319